export const ROUTES = {
  HOME: '/home',
  ALLTRANSACTION: '/allTransaction',
  ALLCREDIT: '/allcredit',
  ALLDEBIT: '/alldebit',
  AAJOURNEY: '/AAJOURNEY',
  DASHBOARD: '/dashboard',
  LANDING: '/landing',
  BUDGET: '/budget',
  GOALS: '/goals',
  BUDGET_DETAIL: '/budget-detail',
  GOALDETAILS: '/goalDetails',
  ERROR: '/error',
  ETBCUSTOMERSCREEN: '/etbcustomerScreen',
  HOLDINGS: '/holdings',
  JFS_BANK_ACCOUNT_DETAIL: '/bank-account-detail',
  JFS_ALL_TRANSACTIONS: '/all-transactions',
  JFS_CATEGORY_TRANSACTIONS: '/category-transactions',
  JFS_TRANSACTION_HISTORY: '/transaction-history',
  STOCKS_ETFS: '/stocks-etfs',
  MUTUAL_FUNDS: '/mutual-funds',
  JFS_FAQ: '/faq',
  JFS_WELCOME: '/welcome',
  JFS_ACCOUNT_DETAIL: '/account-detail',
  JFS_NUDGES: '/jfs-nudges',
  JFS_NUDGES_LINK_ACCOUNTS: '/jfs-nudges-link-accounts',
  JFS_DATA_FAILED: '/data-failed',
  FD_FIP_SELECTION : '/fd-fip-selection',
  FD_ADD_SCREEN : '/fd-add-screen',
  FIXED_DEPOSITS : '/fixed-deposits',
  FD_DETAILS_SCREEN : '/fd-details',
  FD_ADD_SUCCESS : '/fd-add-success',
  PENSION_BAZAAR_EPF: '/pension-bazaar-epf',
  PENSION_BAZAAR_EPF_LOADING: '/pension-bazaar-epf-loading',
  PENSION_BAZAAR_EPF_ERROR: '/pension-bazaar-epf-error',
  PENSION_BAZAAR_EPF_PASSBOOK: '/pension-bazaar-epf-passbook',
  PENSION_BAZAAR_EPF_ALL_EMPLOYERS: '/pension-bazaar-epf-all-employers',
  PENSION_BAZAAR_EPF_ACCOUNT_DETAILS: '/pension-bazaar-epf-account-details',
  PENSION_BAZAAR_V2_EPF: '/pension-bazaar-v2-epf',
  PENSION_BAZAAR_V2_EPF_LOADING: '/pension-bazaar-v2-epf-loading',
  PENSION_BAZAAR_V2_EPF_ERROR: '/pension-bazaar-v2-epf-error',
  PENSION_BAZAAR_V2_EPF_PASSBOOK: '/pension-bazaar-v2-epf-passbook',
  PENSION_BAZAAR_V2_EPF_ALL_EMPLOYERS: '/pension-bazaar-v2-epf-all-employers',
  PENSION_BAZAAR_V2_EPF_ACCOUNT_DETAILS: '/pension-bazaar-v2-epf-account-details',
  AU_WELCOME: '/au-welcome',
  AU_SPENDS: '/au-spends',
  AU_STOCKS: '/au-stocks',
  AU_NUDGES: '/au-nudges',
  AU_FDRD: '/au-fdrd',
  AU_EPF: '/au-epf',
  AU_EPF_PASSBOOK: '/au-epf-passbook',
  AU_EPF_ALL_EMPLOYERS: '/au-epf-all-employers',
  AU_EPF_ACCOUNT_DETAILS: '/au-epf-account-details',
  AU_MUTUAL_FUNDS: '/au-mutual-funds',
  AU_NPS: '/au-nps',
  AU_CREDIT_HEALTH: '/credit-health',
  YB_FINANCIAL_RECAP: '/financial-recap',
  JFS_NPS: '/nps',
  COMMON_TENANT_SPENDS: '/common-tenant-spends',
  COMMON_TENANT_STOCKS: '/common-tenant-stocks',
  COMMON_TENANT_MF: '/common-tenant-mf',
  COMMON_TENANT_NUDGES: '/common-tenant-nudges',
  COMMON_TENANT_EPFO: '/common-tenant-epfo',
  COMMON_TENANT_FDRD: '/common-tenant-fdrd',
  COMMON_TENANT_NPS: '/common-tenant-nps',
  COMMON_TENANT_FINANCIAL_QUIZ: '/common-tenant-financial-quiz',
  COMMON_TENANT_FINANCIAL_QUIZ_RULES: '/common-tenant-financial-quiz-rules',
  COMMON_TENANT_FINANCIAL_QUIZ_PLAYER: '/common-tenant-financial-quiz-player',
  COMMON_TENANT_FINANCIAL_QUIZ_COMPLETE: '/common-tenant-financial-quiz-complete',
  COMMON_TENANT_MULTI_ASSET: '/common-tenant-multi-asset',
  AU_INSURANCE_DETAIL: '/au-insurance-detail',
  SIB_SPENDS: '/sib-spends',
  SIB_FAQ: '/sib-faq',
};
